export enum AnalyticsEventType {
	CONTENT_VIEW = 'content_view',
	CONTENT_DOWNLOAD = 'content_download',
	USER_LOGIN = 'user_login',
  NAVIGATION = 'navigation',
  SHARED_LINK_OPEN = 'shared_link_open',
  WISHLIST_SHARE = 'wishlist_share',

}

export enum ContentType {
	DOCUMENT = 'document',
	IMAGE = 'image',
	VIDEO = 'video',
}

export interface BaseAnalyticsEvent {
	// user_id: string;
	// user_group?: string;
	timestamp: number;
	event_type: AnalyticsEventType;
}

export interface ContentViewEvent extends BaseAnalyticsEvent {
	content_id: string;
	content_name: string;
	content_type?: ContentType;
	content_url: string;
	product_id?: string;
	product_name?: string;
	collection_id?: string;
	collection_name?: string;
	file_extension?: string;
}

export interface ContentDownloadEvent extends ContentViewEvent {
	file_size?: number;
	download_method: 'direct' | 'browser';
}

export interface UserLoginEvent extends BaseAnalyticsEvent {
	login_time: number;
	device_type: 'mobile' | 'tablet' | 'desktop' | 'electron';
	platform: 'ios' | 'android' | 'desktop';
}

export interface NavigationEvent extends BaseAnalyticsEvent {
  page: string;
  product_id?: string;
  product_name?: string;
}

export interface SharedLinkOpenEvent {
  viewer_type: 'authenticated' | 'guest';
  content_id: string;
  content_type: 'wishlist' | 'unknown';
  content_name: string;
  timestamp: number;
  referrer?: string;
}

// Tipo unione per tutti gli eventi
export type AnalyticsEventData = ContentViewEvent | ContentDownloadEvent | UserLoginEvent | NavigationEvent | SharedLinkOpenEvent;
